<template>
	<v-form>
		<v-card-title>开始烘焙</v-card-title>
		<v-card-text>
			<div class="d-flex flex-row align-center">
				<v-text-field
					v-model="form.name"
					:error-messages="errors.name"
					label="烘焙ID（默认格式为 BeanProfileName + Y-m-d + #N)"
				></v-text-field>
			</div>
			<div class="d-flex flex-row align-center">
				<date-picker v-model="form.date" label="烘焙日期"></date-picker>
			</div>
			<div class="d-flex flex-row flex-wrap align-center">
				<div>
					<bean-selector @selected="onBeanSelected">选择生豆</bean-selector>
					<v-alert type="warning" dense v-if="!form.bean_id && errors.bean_id">{{ errors.bean_id }}</v-alert>
				</div>

				<v-chip color="warning">合计{{ totalQty }} 克</v-chip>
				<template v-if="selectableBatches && selectableBatches.length > 0">
					<v-select
						v-model="selectedBatchId"
						:items="selectableBatches"
						:item-title="(item) => `${item.date} ${item.bean_type} ${item.type} - ${item.currentqty}g`"
						item-value="id"
						label="选择批次"
					></v-select>
				</template>

				<template v-if="form.bean_id && selectedBatch">
					<v-text-field
						type="number"
						v-model.number="selectedBatchQty"
						id="beanTemp"
						style="max-width: 10rem"
					></v-text-field>
					克/ {{ selectedBatch.currentqty }} 克
					<v-btn @click="addBatch" :disabled="!selectedBatch.id || selectedBatchQty <= 0" color="primary">
						添加
					</v-btn>
				</template>
			</div>
			<v-alert type="warning" dense v-if="errors.items">{{ errors.items }}</v-alert>
			<v-table v-if="form.items && form.items.length > 0" density="compact">
				<thead>
					<tr>
						<th class="text-left">批次ID</th>
						<th class="text-left">批次日期</th>
						<th class="text-left">数量</th>
						<th class="text-left">操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(batch, i) in form.items" :key="i">
						<td>{{ batch.beanbatch_id }}</td>
						<td>{{ batch.date }}</td>
						<td>{{ batch.qty }} 克</td>
						<td>
							<v-btn @click="form.items.splice(i, 1)" text color="error"><v-icon>$delete</v-icon></v-btn>
						</td>
					</tr>
				</tbody>
			</v-table>
		</v-card-text>
		<slot name="actions" :object="form"></slot>
	</v-form>
</template>

<script>
import BeanSelector from '../bean/Selector.vue'
import DatePicker from '../common/DatePicker.vue'
import { clone } from 'lodash-es'

export default {
	components: {
		BeanSelector,
		DatePicker
	},
	props: {
		value: { type: Object, default: null },
		errors: { type: Object, default: () => ({}) }
	},
	data() {
		return {
			form: {
				items: []
			},
			selectedBean: {},
			selectableBatches: [],
			selectedBatchId: null,
			selectedBatchQty: null
		}
	},
	mounted() {
		if (this.value) {
			this.form = { ...this.form, ...clone(this.value) }
		}
	},
	computed: {
		totalQty() {
			return this.form.items.reduce((acc, cur) => acc + cur.qty, 0)
		},
		selectedBatch() {
			return this.selectableBatches.find((e) => e.id == this.selectedBatchId)
		}
	},
	watch: {
		form: {
			handler(val) {
				this.form.name = this.generatedName()
			},
			deep: true
		}
	},
	methods: {
		generatedName() {
			let name = new Date().toISOString().slice(0, 10)
			if (this.selectedBean && this.selectedBean.name) {
				name += `${this.selectedBean.name}`
			}
			if (this.totalQty) {
				name += `${this.totalQty}g`
			}
			return name
		},
		onBeanSelected(beanids, beans) {
			this.form.bean_id = beanids[0]
			this.selectedBean = beans[0]
			this.form.items = [] //选择其他豆时需要清空批次信息
			this.selectableBatches = []
			let params = {
				bean_id: this.form.bean_id,
				bean_type: 'green',
				currentQty: ' > 0'
			}
			this.$api.bean.searchBatch(params, (res) => {
				if (res.total > 0) {
					this.selectableBatches = res.objects
					if (this.selectableBatches.length == 1) this.selectedBatchId = this.selectableBatches[0].id
				} else {
					alert('没有可用的「生豆」批次，请先添加批次')
				}
			})
		},
		addBatch() {
			console.log('addBatch', this.selectedBatch, this.selectedBatchQty)
			let ex = this.form.items.find((e) => e.beanbatch_id == this.selectedBatch.id)
			if (ex) {
				ex.qty += parseInt(this.selectedBatchQty)
			} else {
				this.form.items.push({
					beanbatch_id: this.selectedBatch.id,
					qty: parseInt(this.selectedBatchQty),
					date: this.selectedBatch.date, //批次日期
					seq: this.selectedBatch.seq //批次序号
				})
				console.log('form.items', this.form.items)
			}
			this.form.inQty = this.totalQty
			this.selectedBatchQty = null
			this.selectedBatchId = null
			this.$emit('update:value', this.form)
		}
	}
}
</script>
